import { frontendURL } from '../../../../helper/URLHelper';
import SettingsWrapper from '../SettingsWrapper.vue';
import AutomatedEmails from './Index.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/automated-emails'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          name: 'automated_emails_index',
          component: AutomatedEmails,
          meta: {
            permissions: ['administrator', 'automated_email_manage'],
          },
        },
      ],
    },
  ],
};
